import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from 'store';
import KioskStyleBase from 'theme/KioskStyleBase';
import MainRoutes from 'routes';
import * as serviceWorker from './serviceWorker';
import { PersistGate } from 'redux-persist/integration/react';
import 'services/translation/i18n';
import 'assets/fonts/fonts.css';

const AppShell: React.FC = () => {
  const onContextMenu = (event: MouseEvent) => {
    event.preventDefault();
  };

  const onTouch = (event: TouchEvent) => {
    if (event.touches.length > 1) event.preventDefault();
  };

  React.useEffect(() => {
    document.addEventListener('contextmenu', onContextMenu, false);
    document.addEventListener('touchmove', onTouch, { passive: false });

    const isPreviewMode = window.location.href.includes('id=') && window.location.href.includes('&key=');
    if (isPreviewMode) {
      const kioskId = atob(window.location.href.split('id=')[1].split('&key=')[0]);
      const key = window.location.href.split('key=')[1];
      sessionStorage.setItem('mode', 'preview');
      sessionStorage.setItem('kioskId', kioskId);
      sessionStorage.setItem('token', key);
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <Suspense fallback="">
            <MainRoutes />
          </Suspense>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <>
    <KioskStyleBase />
    <AppShell />
  </>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
